var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-16-path",
    d: "M1.86719 5.59437L6.3307 10.0579L15.2577 1.13086",
    stroke: "#2E75FF",
    strokeWidth: 1.91293,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-16-path_2",
    d: "M10.7969 10.0579L19.7239 1.13086",
    stroke: "#2E75FF",
    strokeWidth: 1.91293,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTickIcon);
export default __webpack_public_path__ + "static/media/DoubleTickIcon.bbcb3ee2ea8b3b8da51707e3a9515a43.svg";
export { ForwardRef as ReactComponent };